var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAgreementsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE4BC",
    d: "M1 16.724h2.4c.663 0 1.2-.529 1.2-1.181V7.28H1v9.444zm1.8-2.36c.331 0 .6.265.6.592 0 .326-.269.59-.6.59a.595.595 0 01-.6-.59c0-.327.269-.591.6-.591zm15.349-9.106a1.203 1.203 0 00-.849-.348h-3.22c-.3 0-.589.11-.81.31L9.584 8.543l-.011.015a1.453 1.453 0 00-.08 2.067c.477.513 1.478.65 2.105.1.003-.004.01-.004.015-.008l2.996-2.702a.606.606 0 01.846.055.584.584 0 01-.036.816l-.979.883 5.46 4.363c.106.087.205.183.296.285V7.273L18.15 5.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M21.4 7.28v8.266a1.19 1.19 0 001.2 1.182H25V7.28h-3.6zm1.8 8.266a.595.595 0 01-.6-.59c0-.327.269-.591.6-.591.331 0 .6.264.6.59a.595.595 0 01-.6.591zm-4.054-.494l-5.599-4.475-1.125 1.015a2.73 2.73 0 01-3.81-.25 2.63 2.63 0 01.162-3.667L11.84 4.91H8.7c-.318 0-.623.125-.848.347L5.8 7.273v8.266h.686l3.394 3.024a2.426 2.426 0 003.375-.344l.008-.007.67.572a1.41 1.41 0 001.961-.198l.001-.001 1.178-1.425.202.162c.515.41 1.27.333 1.688-.173l.356-.432a1.17 1.17 0 00-.173-1.665z"
  }))));
}

export default SvgAgreementsActive;